ixModuleRouting(
    "impactx.cancellation",
    {
        "/cancelrequest": {
            template: "<ixa-cancel-request-detail></ixa-cancel-request-detail>",
            templateUrl:
                "modules/cancellation/templates/cancellationdetail.tmpl.html",
            controller: "CancelRequestCtrl",
            controllerAs: "cancelCtrl",
            process: "Cancellation",
            workspace: "shop",
        },
        "/canceldemand": {
            template: "<ixa-cancel-demand-detail></ixa-cancel-demand-detail>",
            templateUrl:
                "modules/cancellation/templates/cancellationdetail.tmpl.html",
            controller: "CancelDemandCtrl",
            controllerAs: "cancelCtrl",
            process: "Cancellation",
            workspace: "shop",
        },
        "/crhlistbuyer": {
            template: "<ixa-crh-buyer-list></ixa-crh-buyer-list>",
            templateUrl:
                "modules/cancellation/templates/crhlistbuyer.tmpl.html",
            controller: "CRHBuyerListCtrl",
            controllerAs: "crhBuyerListCtrl",
            process: "Status",
            workspace: "shop",
        },
        "/crhlistpurchaser": {
            template: "<ixa-crh-purchaser-list></ixa-crh-purchaser-list>",
            templateUrl:
                "modules/cancellation/templates/crhlistpurchaser.tmpl.html",
            controller: "CRHPurchaserListCtrl",
            controllerAs: "crhPurchaserListCtrl",
            process: "PurchaseOrderList",
            workspace: "shop",
        },
        "/crhdetails/:id": {
            template: "<ixa-cancellation-request></ixa-cancellation-request>",
            templateUrl:
                "modules/cancellation/templates/cancellationrequest.tmpl.html",
            controller: "CancellationRequestCtrl",
            controllerAs: "cancellationRequestCtrl",
            process: "PurchaseOrderView",
            workspace: "shop",
        },
        "/crhlistsupplier": {
            template: "<ixa-crh-supplier-list></ixa-crh-supplier-list>",
            templateUrl:
                "modules/cancellation/templates/crhlistsupplier.tmpl.html",
            controller: "CRHSupplierListCtrl",
            controllerAs: "crhSupplierListCtrl",
            process: "CancellationRequestSupplier",
            workspace: "shop",
        },
        "/crhdetailssupplier/:id/": {
            template: "<ixa-cancellation-request-supplier></ixa-cancellation-request-supplier>",
            templateUrl:
                "modules/cancellation/templates/cancellationrequestsupplier.tmpl.html",
            controller: "CancellationRequestSupplierCtrl",
            controllerAs: "cancellationRequestCtrl",
            process: "CancellationRequestSupplier",
            workspace: "shop",
        },
        "/crhdetailssupplier/:id/:action": {
            template: "<ixa-cancellation-request-supplier></ixa-cancellation-request-supplier>",
            templateUrl:
                "modules/cancellation/templates/cancellationrequestsupplier.tmpl.html",
            controller: "CancellationRequestSupplierCtrl",
            controllerAs: "cancellationRequestCtrl",
            process: "CancellationRequestSupplier",
            workspace: "shop",
        },
    },
    ["ngRoute", "impactx.statusicon"]
);
